import { render, staticRenderFns } from "./TemplateDesigner.vue?vue&type=template&id=24d04f90&scoped=true"
import script from "./TemplateDesigner.vue?vue&type=script&lang=js"
export * from "./TemplateDesigner.vue?vue&type=script&lang=js"
import style0 from "./TemplateDesigner.vue?vue&type=style&index=0&id=24d04f90&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d04f90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d04f90')) {
      api.createRecord('24d04f90', component.options)
    } else {
      api.reload('24d04f90', component.options)
    }
    module.hot.accept("./TemplateDesigner.vue?vue&type=template&id=24d04f90&scoped=true", function () {
      api.rerender('24d04f90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/print-template/TemplateDesigner.vue"
export default component.exports